import { AccommodationPlaceRoomBlockStatus, GuestEventHotelRoomBlocksQuery, TravelDistancesBetweenPointsResponseFragment } from '@graphql/generated';
export type AccommodationPlacesV2 = NonNullable<NonNullable<GuestEventHotelRoomBlocksQuery['event']>['accommodationPlacesV2'][number]>;

export enum AccommodationCombinedType {
  Roomblock = 'Roomblock',
  Hotel = 'Hotel',
  Custom = 'Custom',
}

export enum AccommodationSourceType {
  HotelMapList = 'hotel_map_list',
  MapIconModal = 'map_icon_modal',
  AccomPageGrid = 'accom_page_grid',
}

export interface AccommodationCombined {
  id: string;
  index?: number;
  type: AccommodationCombinedType;

  //   General Information
  displayName?: Maybe<string>;
  address?: Maybe<string>;
  customAddress?: Maybe<string>;
  city?: Maybe<string>;
  country?: Maybe<string>;
  state?: Maybe<string>;
  postalCode?: Maybe<string>;
  latitude?: Maybe<number>;
  longitude?: Maybe<number>;
  distance?: number | null;
  distances?: Maybe<TravelDistancesBetweenPointsResponseFragment>;

  description?: Maybe<string>;
  email?: Maybe<string>;
  phone?: Maybe<string>;
  url?: Maybe<string>;
  customUrl?: Maybe<string>;

  joyPlaceId?: Maybe<string>;

  //   Provider Information
  googlePlaceId?: Maybe<string>;
  zhId?: Maybe<string>;

  //   Extra Information
  pricePerNight?: Maybe<number>;
  bookingUrl?: Maybe<string>;
  cutoffDate?: Maybe<string>;
  checkOutDate?: Maybe<string>;
  checkInDate?: Maybe<string>;
  strikeoutPricePerNight?: Maybe<number>;
  numberOfRoomsReserved?: Maybe<number>;
  interestedGuestCount?: Maybe<number>;
  isJoyManagedRoomBlock?: Maybe<boolean>;

  //   Custom Properties
  isFavorite?: Maybe<boolean>;
  starRating?: Maybe<number>;

  photo: Maybe<{
    id?: Maybe<string>;
    url?: Maybe<string>;
  }>;

  status?: Maybe<AccommodationPlaceRoomBlockStatus>;
  isFromAccommodationCatalog: Maybe<boolean>;
  isCustomLinkEnabled?: Maybe<boolean>;
}
